import Logout from '@/components/logout/Logout';
import Login from '@/components/login/Login';
export default [

{
  path: '*',
  meta: {
    public: true,
  },
  redirect: {
    path: '/404'
  }
},  
{
  path: '/404',
  meta: {
    public: true,
  },
  name: 'NotFound',
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/pages/NotFound.vue`
    )
},
{
  path: '/403',
  meta: {
    public: true,
  },
  name: 'AccessDenied',
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/pages/Deny.vue`
    )
},
{
  path: '/500',
  meta: {
    public: true,
  },
  name: 'ServerError',
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/pages/Error.vue`
    )
},
{
  path: '/',
  meta: { },
  name: 'Root',
  redirect: {
    name: 'Login'
  }
},
{
  path: '/dashboard',
  meta: { breadcrumb: true },
  name: 'Dashboard',
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/dashboard/Dashboard.vue`
    )
},
{
  path: '/empresas',
  meta: { breadcrumb: true },
  name: 'Empresas',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/empresas/Empresas.vue`
    )
},      
{
  path: '/treinamentos',
  meta: { },
  name: 'Treinamentos',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/treinamentos/Treinamentos.vue`
    )
},
{
  path: '/turmas',
  meta: { },
  name: 'Turmas',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/turmas/Turmas.vue`
    )
},
{
  path: '/instrutores',
  meta: { },
  name: 'Instrutores',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/instrutores/Instrutores.vue`
    )
},
{
  path: '/agendamentos',
  meta: { breadcrumb: true },
  name: 'agendamentos/Agendamentos',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/agendamentos/Agendamentos.vue`
    )
},
{
  path: '/day',
  meta: { breadcrumb: true },
  name: 'agendamentos/Day',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/agendamentos/Day.vue`
    )
},
{
  path: '/agendar',
  meta: { breadcrumb: true },
  name: 'agendamentos/Agendar',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/agendamentos/Agendar.vue`
    )
},
{
  path: '/usuarios',
  meta: { },
  name: 'Usuarios',
  props: (route) => ({ type: route.query.type }),
  component: () => import(
    /* webpackChunkName: "routes" */
    /* webpackMode: "lazy-once" */
    `@/components/usuarios/Usuarios.vue`
    )
},
{
  path: '/login',
    meta: {
    public: true,
  },
  name: 'Login',
  component: Login
},
{
  path: '/logout',
  name: 'Logout',
  component: Logout
},




];



// WEBPACK FOOTER //
// ./src/router/paths.js